import styled from "styled-components";
import tw from "twin.macro";
import { NavBar } from "../../components/NavBar";
import { FooterIconSection } from "../../components/FooterIcons";
import { WhoAreWeSection } from "../../containers/WhoAreWe";


import EtherealBanner from "../../images-optimized/ethereal-collage.webp";

const AboutUsContainer = styled.div`
    ${tw`
        w-full
        flex
        flex-col
        h-full
        relative
        align-items[center]
    `}
`;

const NavBG = tw.div`
    w-full
    background-color[#87bbb8]
`

const LandingSection = styled.div`
  ${tw`
        w-full
        // h-screen
        overflow-scroll
        flex
        flex-col
    `};
`;

const ImageBanner = styled.div`
    ${tw`
        grid 
        max-w-full
        lg:grid 
    `}
`

export function AboutUs() {
    return (
        <AboutUsContainer>
            <NavBG><NavBar /></NavBG>
            <WhoAreWeSection></WhoAreWeSection>
            <img src={EtherealBanner} />
            <FooterIconSection></FooterIconSection>
        </AboutUsContainer>)
};
